import { HttpClient } from '@remodeling/base';
import {
  GetVisitConsultItemCodeResponse,
  GetVisitConsultTimeCodeResponse,
  GetVisitConsultUserInfoResponse,
  CreateVisitConsultRequestReservationRequest,
  CreateVisitConsultRequestReservationResponse,
  CancelVisitConsultUsersReservationRequest,
  CancelVisitConsultUsersReservationResponse,
  GetVisitConsultUsersReservationRequest,
  GetVisitConsultUsersReservationResponse,
  GetVisitConsultChannelInfoRequest,
  GetVisitConsultChannelInfoResponse,
  GetVisitConsultBasicInfoResponse,
  GetVisitConsultItemCodeRequest,
  GetConsultInfoRequest,
} from '../../model';

export class CreateVisitConsultRequestReservationGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: CreateVisitConsultRequestReservationRequest) {
    return await this.httpClient.request<CreateVisitConsultRequestReservationResponse>(
      {
        method: 'POST',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/visit-consults/reservation`,
        body: req,
      },
    );
  }
}

export class GetVisitConsultItemCodeGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetVisitConsultItemCodeRequest) {
    return await this.httpClient.request<GetVisitConsultItemCodeResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/visit-consults/reservation/item-code/${req.shopId}`,
    });
  }
}

export class GetVisitConsultTimeCodeGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetVisitConsultTimeCodeResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/visit-consults/reservation/time-code`,
    });
  }
}

export class GetVisitConsultUserInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec() {
    return await this.httpClient.request<GetVisitConsultUserInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/visit-consults/user-info`,
    });
  }
}

export class GetVisitConsultUsersReservationGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetVisitConsultUsersReservationRequest) {
    return await this.httpClient.request<GetVisitConsultUsersReservationResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/visit-consults/reservation`,
        body: req,
      },
    );
  }
}

export class CancelVisitConsultUsersReservationGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: CancelVisitConsultUsersReservationRequest) {
    return await this.httpClient.request<CancelVisitConsultUsersReservationResponse>(
      {
        method: 'DELETE',
        url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/visit-consults/${req.visitConsultId}/reservation`,
      },
    );
  }
}

export class GetVisitConsultChannelInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetVisitConsultChannelInfoRequest) {
    return await this.httpClient.request<GetVisitConsultChannelInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/consults/base/channel`,
      body: req,
    });
  }
}

export class GetVisitConsultBasicInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req?: GetConsultInfoRequest) {
    return await this.httpClient.request<GetVisitConsultBasicInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/consults/info`,
      body: req,
    });
  }
}
